import { render } from "./RecoveryBody.vue?vue&type=template&id=7a2e3256&scoped=true"
import script from "./RecoveryBody.vue?vue&type=script&lang=js"
export * from "./RecoveryBody.vue?vue&type=script&lang=js"

import "./RecoveryBody.vue?vue&type=style&index=0&id=7a2e3256&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7a2e3256"]])

export default __exports__